import { ReactNode } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Breadcrumbs from "./Breadcrumbs";
import SEO from "@/components/SEO";

interface LayoutProps {
  children: ReactNode;
  seoTitle?: string;
  seoDescription?: string;
  seoJsonLd?: Record<string, unknown> | Record<string, unknown>[];
  noIndex?: boolean;
}

const Layout = ({ children, seoTitle, seoDescription, seoJsonLd, noIndex }: LayoutProps) => {
  return (
    <div className="flex min-h-screen flex-col">
      <SEO title={seoTitle} description={seoDescription} jsonLd={seoJsonLd} noIndex={noIndex} />
      <Header />
      <Breadcrumbs />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
